var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:({ width: _vm.size + 'px' })},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",style:({ stroke: _vm.color }),attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"2","stroke-miterlimit":"10"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }